<template lang="pug">
	modal(:max-width="400")
		.card.text-left
			.card-header
				span.fa.fa-search.mr-2
				| Búqueda de ficheros
				button.close(@click="cerrar") &times;
			.card-body.bg-light
				.input-group
					.input-group-prepend
						.input-group-text
							span.fa.fa-search
					input.form-control(v-model="cadena", @keypress.enter="buscar")
					.input-group-append
						button.btn.btn-primary(@click="buscar")
							span.fa.fa-gear
			div.table-responsive(style="max-height:400px;overflow-y:auto")
				table.table.table-striped(
					tabindex="5"
					@keydown="teclaAbajo"
					@keyup="teclaArriba"
				)
					tbody
						tr(
							v-for="fichero in listadoFicheros"
							:key="fichero.ObjetoID"
							@dragstart="dragStart($event, fichero)"
							:class="(seleccion.indexOf(fichero) >= 0) ? 'bg-info' : ''"
							@click="seleccionaFichero(fichero)"
							draggable
							:id="'fichero-' + fichero.ObjetoID"
						)
							td.p-1.text-left {{fichero.ObjetoDescripcion}}
							td.p-1.text-right {{_getDuracionFisica(fichero.ObjetoDuracion)}}
</template>


<script>
export default {
	data () {
		return {
			cadena: '',
			listadoFicheros: [],
			ficheroActivo: null,
			seleccion: [],
			indice: 0,
			teclas: {
				ctrl: false,
				shift: false
			}
		}
	},

	methods: {
		buscar () {
			this.seleccion = []
			this.indice = 0
			this.$http.post('organizar-emisoras/php/api/query-ficheros.php', {q: this.cadena})
				.then(res => {
					this.listadoFicheros = res.data.resultados.map(r => r.datos)
				})
				.catch(this.$responseError)
		},
		teclaAbajo (e) {
			if (e.keyCode !== 9) {
				e.preventDefault()
				e.stopPropagation()
			}
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey
			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(this.indice + 1)
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(this.indice - 1)
			} else if (e.keyCode === 32) {
				if (this.seleccion.length > 0) {
					this.$emit('reproducir', this.seleccion[0].ObjetoID)
				}
			}
		},
		teclaArriba (e) {
			e.preventDefault()
			e.stopPropagation()
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey
		},
		seleccionaIndice (i) {
			const tamano = this.listadoFicheros.length
			this.indice = (i >= tamano) ? 0 : (i < 0) ? tamano - 1 : i
			this.seleccion = [this.listadoFicheros[this.indice]]
			document.getElementById('fichero-' + this.seleccion[0].ObjetoID).scrollIntoView({block: 'end', behavior: 'instant'})
		},
		seleccionaFichero (fichero) {
			this.ficheroActivo = fichero
			if (this.teclas.ctrl) {
				const idx = this.seleccion.indexOf(fichero)
				if (idx >= 0) {
					this.seleccion.splice(idx, 1)
				} else {
					this.seleccion.push(fichero)
				}
			} else if (this.teclas.shift) {
				if (this.seleccion.length === 0) {
					this.seleccion = [fichero]
				} else {
					// Hayamos el índice más bajo de la selección
					const indiceSeleccion = this.listadoFicheros.indexOf(fichero)
					let ind = null
					for (let i = 0; i < this.seleccion.length; i++) {
						const e = this.listadoFicheros.indexOf(this.seleccion[i])
						ind = (ind === null || e < ind) ? e : ind
					}

					// Ahora comprobamos si es mayor que el seleccionado
					let primero = (ind > indiceSeleccion) ? indiceSeleccion : ind
					let ultimo = (ind > indiceSeleccion) ? ind : indiceSeleccion

					this.seleccion = []

					for (let p = primero; p <= ultimo; p++) {
						this.seleccion.push(this.listadoFicheros[p])
					}
				}
			} else {
				this.seleccion = [fichero]
			}

			this.indice = this.listadoFicheros.indexOf(fichero)
		},
		dragStart (e, fichero) {
			if (this.seleccion.indexOf(fichero) < 0) {
				this.seleccionaFichero(fichero)
			}

			e.dataTransfer.setData('text/json', JSON.stringify(this.seleccion))
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		},

		_getDuracionFisica (dur) {
			let valor = dur
			let neg = (valor < 0)
			valor = (valor < 0) ? valor * -1 : valor
			let h = '00'
			let m = '00'
			let s = '00'
			let decimas = '000'
			decimas = (valor.toString().match(/\./)) ? valor.toString().split('.')[1] : '000'

			if (valor >= 3600) {
				h = Math.floor(valor / 3600)
				h = (h < 10) ? '0' + h : h
				valor = valor % 3600
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60)
				m = (m < 10) ? '0' + m : m
				valor = valor % 60
			}

			s = parseInt(valor)
			s = (s < 10) ? '0' + s : s

			decimas = decimas.toString()
			while (decimas.length < 3) {
				decimas = decimas + '0'
			}

			const menos = (neg) ? '-' : ''
			return menos + '' + h + ':' + m + ':' + s
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/busqueda-global.vue